import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Mail, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatErr } from "../lib/api";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_8f20c47c-6306-4c92-aa61-f6db9e4c740d/artifacts/cc7z0gyj_ChatGPT%20Image%20Apr%2026%2C%202026%2C%2010_37_30%20AM.png";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const { data } = await api.post("/admin/login", { email, password });
      const token = data.access_token || data.token;
      if (!token) throw new Error("No token in response");
      localStorage.setItem("zumroo_token", token);
      localStorage.setItem("zumroo_admin_email", data.email || data.user?.email || email);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      toast.error(formatErr(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center p-4 bg-dots">
      <form
        onSubmit={submit}
        className="zcard w-full max-w-md p-8 sm:p-10 bg-white"
        data-testid="admin-login-form"
      >
        <div className="flex items-center gap-2 mb-7">
          <img src={LOGO_URL} alt="Zumroo" className="w-11 h-11 rounded-lg" />
          <div>
            <div className="font-display font-bold text-xl">
              <span className="text-[#0F172A]">zum</span>
              <span className="text-[#10B981]">roo</span>
            </div>
            <div className="text-xs text-slate-500">Admin console</div>
          </div>
        </div>

        <h1 className="text-2xl font-bold tracking-tight">Sign in to manage</h1>
        <p className="text-slate-500 text-sm mt-1">Use your admin credentials.</p>

        <div className="mt-6 space-y-4">
          <div>
            <label className="block text-xs font-bold text-slate-700 mb-1.5 uppercase tracking-wide">Email</label>
            <div className="relative">
              <Mail className="w-4 h-4 absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400" />
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full pl-10 pr-4 py-3 rounded-xl border border-slate-200 focus:border-[#10B981] focus:ring-2 focus:ring-emerald-100 outline-none"
                placeholder="admin@zumroo.in"
                data-testid="admin-email-input"
                required
              />
            </div>
          </div>
          <div>
            <label className="block text-xs font-bold text-slate-700 mb-1.5 uppercase tracking-wide">Password</label>
            <div className="relative">
              <Lock className="w-4 h-4 absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400" />
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full pl-10 pr-4 py-3 rounded-xl border border-slate-200 focus:border-[#10B981] focus:ring-2 focus:ring-emerald-100 outline-none"
                placeholder="••••••••"
                data-testid="admin-password-input"
                required
              />
            </div>
          </div>
        </div>

        <button
          type="submit"
          disabled={loading}
          className="btn-primary w-full justify-center mt-6"
          data-testid="admin-login-btn"
        >
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : null}
          {loading ? "Signing in…" : "Sign in"}
        </button>

        <a href="/" className="block mt-6 text-center text-sm text-slate-500 hover:text-slate-900">
          ← Back to website
        </a>
      </form>
    </div>
  );
}
